import CalendarList from '@/components/desktop/CalendarList';
import IOSSwitch from '@/components/IosSwitch';
import { setShowCalendarVietNam } from '@/slices/calendar/calendarSlice';
import { ILangObj } from '@/slices/goyoloSeo/sliceType';
import { style } from '@/styles/globals';
import { useAppDispatch, useAppSelector } from '@/utils/hook';
import { pr } from '@/utils/pxToRem';
import {
  CircularProgress,
  FormControlLabel,
  FormGroup,
  Stack,
  Typography,
} from '@mui/material';
import React, { useEffect, useLayoutEffect } from 'react';
import { ContentContainer } from '../SelectArea';

interface DesktopCalendarProps {
  isLoading?: boolean;
  type: 'depart' | 'return';
  dayPriceObj: any;
  selectedDate: any;
  setSelectedDateFunc: any;
  isDisableRoundTrip?: boolean;
  isLunarYearMode?: boolean;
  disableChangeMonth?: boolean;
  limit?: number,
  lang?: ILangObj,
}

const DesktopCalendar: React.FC<DesktopCalendarProps> = ({
  isLoading,
  type,
  disableChangeMonth,
  limit,
  selectedDate,
  isLunarYearMode,
  dayPriceObj,
  setSelectedDateFunc,
  isDisableRoundTrip,
  lang,
}) => {
  const isShowCalendarVietNam = useAppSelector(
    (state) => state.calendar.showCalendarVietNam,
  );
  const dispatch = useAppDispatch();
  return (
    <ContentContainer
      style={{
        padding: `${pr`16px`} 0`,
        overflow: 'hidden',
      }}
    >
      <Stack
        sx={{
          zIndex: 10,
        }}
      >
        <FormGroup
          style={{
            display: 'flex',
            textAlign: 'end',
            marginBottom: pr`10`,
          }}
        >
          <FormControlLabel
            style={{
              justifyContent: 'flex-end',
              marginLeft: '10px',
            }}
            componentsProps={{
              typography: {
                ...style.text.content.regular,
                color: style.color.black2,
              },
            }}
            control={(
              <IOSSwitch
                size="small"
                color="secondary"
                defaultChecked={isShowCalendarVietNam}
                checked={isShowCalendarVietNam}
              />
            )}
            label={(
              <Typography
                variant="body2"
                sx={{ marginLeft: '8px' }}
              >
                {lang?.global?.lunarYear || 'Lịch âm'}
              </Typography>
            )}
            defaultChecked={isLunarYearMode || isShowCalendarVietNam}
            onChange={(value: any) => dispatch(
              setShowCalendarVietNam({ value: value?.target?.checked }),
            )}
          />
        </FormGroup>
      </Stack>
      {isLoading ? (
        <div
          style={{
            width: '100%',
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <CircularProgress color="inherit" />
        </div>
      ) : (
        <CalendarList
          lang={lang}
          disableChangeMonth={disableChangeMonth}
          limit={limit}
          isLunarYearMode={isLunarYearMode}
          isDisableRoundTrip={isDisableRoundTrip}
          type={type}
          dayPriceObj={dayPriceObj}
          selectedDate={selectedDate}
          setSelectedDate={setSelectedDateFunc}
        />
      )}
    </ContentContainer>
  );
};

export default DesktopCalendar;
